import { useEffect, useState } from "react";
import { Zap, Menu, X } from "lucide-react";
import { ZOOMY } from "@/constants/zoomyIds";

const links = [
  { id: "fleet", label: "Fleet", testid: ZOOMY.navFleet },
  { id: "stats", label: "Numbers", testid: ZOOMY.navStats },
  { id: "partner", label: "Partner", testid: ZOOMY.navPartner },
  { id: "contact", label: "Contact", testid: ZOOMY.navContact },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleAnchor = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/85 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 flex items-center justify-between h-16 sm:h-20">
        <a
          href="#top"
          onClick={handleAnchor("top")}
          data-testid={ZOOMY.navLogo}
          className="flex items-center gap-2 group"
        >
          <span className="relative inline-flex items-center justify-center w-8 h-8 bg-lime-400 text-black">
            <Zap className="w-4 h-4" strokeWidth={2.5} fill="currentColor" />
          </span>
          <span className="font-display text-2xl font-black tracking-tight">
            <span className="text-lime-400">ZO</span>
            <span className="text-white">O</span>
            <span className="text-lime-400">MY</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              data-testid={l.testid}
              onClick={handleAnchor(l.id)}
              className="text-sm font-medium text-slate-300 hover:text-lime-400 transition-colors uppercase tracking-wider"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          onClick={handleAnchor("contact")}
          data-testid={ZOOMY.navCta}
          className="hidden md:inline-flex btn-lime items-center gap-2 bg-lime-400 text-black font-bold uppercase tracking-wider text-xs px-5 py-3 hover:bg-lime-300 transition-colors"
        >
          Get in touch
          <Zap className="w-4 h-4" strokeWidth={3} />
        </a>

        <button
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#050505]/95 backdrop-blur-xl border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                data-testid={`${l.testid}-mobile`}
                onClick={handleAnchor(l.id)}
                className="text-base text-slate-200 uppercase tracking-wider font-medium"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={handleAnchor("contact")}
              className="mt-2 inline-flex justify-center bg-lime-400 text-black font-bold uppercase tracking-wider text-xs px-5 py-3"
            >
              Get in touch
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
